export enum CategoryEnum {
    RED = 'red',
    ORANGE = 'orange',
    YELLOW = 'yellow',
    GREEN = 'gree',
    BLACK = 'black',
    UNDEFINED = 'undefined',
}